import React from 'react';
import { Col, Form, Input, Row, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { DistanceFee } from '../../../../../server/src/models';

interface DistanceFeeInputProps {
    isDetailMode: boolean;
    distanceFee: DistanceFee | undefined;
    fieldName: number;
    remove: (index: number | number[]) => void;
}

const DistanceFeeInput: React.FC<DistanceFeeInputProps> = ({
    isDetailMode,
    distanceFee,
    fieldName,
    remove,
}: DistanceFeeInputProps) => {
    return (
        <>
            <Row gutter={24}>
                <Col span={7} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7 }}>
                    <Form.Item
                        labelCol={{ span: 12 }}
                        label={isDetailMode ? undefined : 'First billed Km'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'minKm']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? <span>{distanceFee?.minKm}</span> : <Input type="number" />}
                    </Form.Item>
                </Col>
                <Col span={7} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7 }}>
                    <Form.Item
                        labelCol={{ span: 12 }}
                        label={isDetailMode ? undefined : 'Last Km billed'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'maxKm']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? <span>{distanceFee?.maxKm}</span> : <Input type="number" />}
                    </Form.Item>
                </Col>
                <Col span={7} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7 }}>
                    <Form.Item
                        labelCol={{ span: 12 }}
                        label={isDetailMode ? undefined : 'Fee by Km'}
                        style={{ fontWeight: 'bold' }}
                        name={[fieldName, 'kmFee']}
                        rules={[{ required: !isDetailMode }]}
                    >
                        {isDetailMode ? <span>{distanceFee?.kmFee}</span> : <Input type="number" />}
                    </Form.Item>
                </Col>
                {!isDetailMode && (
                    <Col span={1} offset={1}>
                        <span className="ant-form-text text-secondary" style={{ marginTop: '5px', cursor: 'pointer' }}>
                            <Tag
                                color="warning"
                                style={{ cursor: 'pointer' }}
                                onClick={(): void => remove?.(fieldName)}
                                id={`distance_fee_delete_${fieldName}`}
                            >
                                <DeleteOutlined />
                            </Tag>
                        </span>
                    </Col>
                )}
            </Row>
        </>
    );
};

export default DistanceFeeInput;
